import React, { Component } from 'react'
import MaterialTable from 'material-table'
// import Service from "../../Networking/networkutils";
import { withSnackbar } from 'notistack';
// import Button from '@material-ui/core/Button';
import { LoopCircleLoading } from 'react-loadingg';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { getPrimaryColor, poundFormat } from '../../Helper/CommonThings';
import { Box } from '@material-ui/core';
// import { Box } from '@material-ui/core';
import Moment from 'react-moment';
// import { getCookie } from '../../Helper/CookieHelper';
// import { errorMessage } from '../../Helper/ErrorMessage';


// const token = getCookie("bb_ts_token");
// const user = JSON.parse(getCookie("bb_ts_user"));
class ProjectReportDs extends Component {

    constructor(props) {
        super(props)

        this.state = {
            data: [],
            openAdd: false,
            issueName: '',
            issueComment: '',
            isLoading: true,
        }
    }

    componentDidMount() {
        // console.log(this.props.usage)
        if (this.props.usage.length === 0) {
            var data = {
                'est_hours': 0,
                'est_cost': 0,
                'rev_hours': 0,
                'rev_cost': 0,
                'actual': 0,
                'actual_cost': 0,
                'earned_value': 0,
            }
            this.props.usage.push(data)

        }

        this.setState({
            isLoading: false
        })
    }

    totalCalc(key) {
        var total = 0
        for (let i = 0; i < this.props.value.length; i++) {
            const element = this.props.value[i];
            total += element[key]
        }
        return total
    }

    usageCalc(key) {

        return this.props.usage.length > 0 ? this.props.usage[0][key] : 0
    }

    totalUsageCalc(key) {
        var total = 0
        for (let i = 0; i < this.props.value.length; i++) {
            const element = this.props.value[i];
            total += element[key]
        }
        return total + (this.props.usage.length > 0 ? this.props.usage[0][key] : 0)
    }

    totalUsageDeltaCalc(key) {

        return this.totalUsageCalc("rev_cost") - this.totalUsageCalc("est_cost")
    }

    render() {

        return (
            <div>
                {(this.state.isLoading) ? (
                    <LoopCircleLoading color={getPrimaryColor()} />
                ) : (
                    <div>
                        <Box flexDirection="row-reverse">
                            Date Started in PaRaM : {this.props.usage.length > 0 && this.props.usage[0].date_into_param ? <Moment local format="DD/MM/YYYY">{this.props.usage[0].date_into_param}</Moment> : "Not Available"}
                        </Box>
                        <TableContainer component={Paper}>
                            <Table size="small" aria-label="a dense table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell></TableCell>
                                        <TableCell>Budget Hours</TableCell>
                                        <TableCell>Budget Cost</TableCell>
                                        <TableCell>Hours to date</TableCell>
                                        <TableCell>Cost to date</TableCell>
                                        <TableCell>Cost to Come</TableCell>
                                        <TableCell>At Completion Hours</TableCell>
                                        <TableCell>At Completion Cost</TableCell>
                                        <TableCell>Variance Cost</TableCell>
                                        <TableCell>Earned Value</TableCell>
                                        {/* <TableCell>EV (%)</TableCell> */}


                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableCell>{"Before PaRaM"}</TableCell>
                                    <TableCell>{this.usageCalc("est_hours")}</TableCell>
                                    <TableCell>{poundFormat(this.usageCalc("est_cost"))}</TableCell>
                                    <TableCell>{this.usageCalc("actual")}</TableCell>
                                    <TableCell>{poundFormat(this.usageCalc("actual_cost"))}</TableCell>
                                    <TableCell>{poundFormat(0)}</TableCell>
                                    <TableCell>{this.usageCalc("rev_hours")}</TableCell>
                                    <TableCell>{poundFormat(this.usageCalc("rev_cost"))}</TableCell>
                                    <TableCell>{poundFormat(this.usageCalc("rev_cost") - this.usageCalc("est_cost"))}</TableCell>
                                    <TableCell>{poundFormat(this.usageCalc("earned_value"))}</TableCell>
                                    {/* <TableCell>{"NA"}</TableCell> */}



                                </TableBody>
                                <TableBody>
                                    <TableCell>{"In PaRaM"}</TableCell>
                                    <TableCell>{this.totalCalc("est_hours")}</TableCell>
                                    <TableCell>{poundFormat(this.totalCalc("est_cost"))}</TableCell>
                                    <TableCell>{this.totalCalc("actual")}</TableCell>
                                    <TableCell>{poundFormat(this.totalCalc("actual_cost"))}</TableCell>
                                    <TableCell>{poundFormat(this.totalCalc("cost_to_complete"))}</TableCell>
                                    <TableCell>{this.totalCalc("rev_hours")}</TableCell>
                                    <TableCell>{poundFormat(this.totalCalc("rev_cost"))}</TableCell>
                                    <TableCell>{poundFormat(this.totalCalc("delta_cost"))}</TableCell>
                                    <TableCell>{poundFormat(this.totalCalc("earned_value"))}</TableCell>
                                    {/* <TableCell>{(this.totalCalc("earned_value") / this.totalCalc("est_cost")) * 100}</TableCell> */}



                                </TableBody>
                                <TableBody>
                                    <TableCell>{"Total"}</TableCell>
                                    <TableCell>{this.totalUsageCalc("est_hours")}</TableCell>
                                    <TableCell>{poundFormat(this.totalUsageCalc("est_cost"))}</TableCell>
                                    <TableCell>{this.totalUsageCalc("actual")}</TableCell>
                                    <TableCell>{poundFormat(this.totalUsageCalc("actual_cost"))}</TableCell>
                                    <TableCell>{poundFormat(this.totalCalc("cost_to_complete"))}</TableCell>
                                    <TableCell>{this.totalUsageCalc("rev_hours")}</TableCell>
                                    <TableCell>{poundFormat(this.totalUsageCalc("rev_cost"))}</TableCell>
                                    <TableCell>{poundFormat(this.totalUsageDeltaCalc("delta_cost"))}</TableCell>
                                    <TableCell>{poundFormat(this.totalUsageCalc("earned_value"))}</TableCell>
                                    {/* <TableCell>{(this.totalCalc("earned_value") / this.totalCalc("est_cost")).toFixed(2) * 100}</TableCell> */}



                                </TableBody>
                            </Table>
                        </TableContainer>

                        <MaterialTable
                            title="DS Based Report"
                            columns={[
                                { title: 'DS ID', field: 'id' },
                                { title: 'DS', field: 'name' },
                                {
                                    title: 'Budget Hours', field: 'est_hours',
                                    render: rowData => !rowData.contract_type ? rowData.est_hours : "-"
                                },
                                { title: 'Budget Cost', field: 'est_cost' },
                                {
                                    title: 'Hours to date', field: 'actual',
                                    render: rowData => !rowData.contract_type ? rowData.actual : "-"
                                },
                                { title: 'Cost to date', field: 'actual_cost' },
                                { title: 'Cost to Come', field: 'cost_to_complete' },
                                {
                                    title: 'At Completion Hours', field: 'rev_hours',
                                    render: rowData => !rowData.contract_type ? rowData.rev_hours : "-"
                                },
                                { title: 'At Completion Cost', field: 'rev_cost' },
                                { title: 'Variance Cost', field: 'delta_cost' },

                                { title: 'Earned Value', field: 'earned_value' },
                                { title: 'EV (%)', field: 'ev_percentage' },

                            ]}
                            data={this.props.value}

                            options={{
                                padding: "dense",
                                actionsColumnIndex: -1,
                                pageSize: 10,
                                paging: false,
                                pageSizeOptions: [5, 10, 20],
                            }}

                        />

                    </div>
                )}

            </div>
        )
    }
}

export default withSnackbar(ProjectReportDs);